"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isVideoMarkerTimestampProperty = exports.videoMarkerTimestampPropertyDefinition = void 0;
const VIDEO_MARKER_TIMESTAMP_PATTERN = '^[0-9]{2}:[0-5][0-9]:[0-5][0-9]$';
exports.videoMarkerTimestampPropertyDefinition = {
    name: 'video-marker-timestamp',
    type: 'text',
    multiple: false,
    view: { label: 'Timestamp' },
    constraints: [
        {
            name: 'pattern',
            argument: '^[0-9]{2}:[0-5][0-9]:[0-5][0-9]$',
        },
        {
            name: 'required',
            argument: true,
        },
    ],
};
const isVideoMarkerTimestampProperty = (prop) => {
    return prop.name === exports.videoMarkerTimestampPropertyDefinition.name;
};
exports.isVideoMarkerTimestampProperty = isVideoMarkerTimestampProperty;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoidmlkZW8tbWFya2VyLXRpbWVzdGFtcC5wcm9wZXJ0eS5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9wcm9wZXJ0aWVzL3ZpZGVvLW1hcmtlci10aW1lc3RhbXAucHJvcGVydHkudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7O0FBRUEsTUFBTSw4QkFBOEIsR0FBRyxrQ0FBa0MsQ0FBQTtBQUU1RCxRQUFBLHNDQUFzQyxHQUFHO0lBQ3BELElBQUksRUFBRSx3QkFBd0I7SUFDOUIsSUFBSSxFQUFFLE1BQU07SUFDWixRQUFRLEVBQUUsS0FBSztJQUNmLElBQUksRUFBRSxFQUFFLEtBQUssRUFBRSxXQUFXLEVBQUU7SUFDNUIsV0FBVyxFQUFFO1FBQ1g7WUFDRSxJQUFJLEVBQUUsU0FBUztZQUNmLFFBQVEsRUFBRSxrQ0FBa0M7U0FDN0M7UUFDRDtZQUNFLElBQUksRUFBRSxVQUFVO1lBQ2hCLFFBQVEsRUFBRSxJQUFJO1NBQ2Y7S0FDRjtDQUM4QixDQUFBO0FBSTFCLE1BQU0sOEJBQThCLEdBQUcsQ0FBQyxJQUFrQixFQUF3QyxFQUFFO0lBQ3pHLE9BQU8sSUFBSSxDQUFDLElBQUksS0FBSyw4Q0FBc0MsQ0FBQyxJQUFJLENBQUE7QUFDbEUsQ0FBQyxDQUFBO0FBRlksUUFBQSw4QkFBOEIsa0NBRTFDIn0=